import { ClipboardCheck, Factory, HandHelping } from 'lucide-react';

import { defineArea } from '../../app/area';
import { ProductionOrderDetailPage } from './pages/ProductionOrderDetailPage';
import { ProductionOrdersPage } from './pages/ProductionOrdersPage';
import { ProductionRequestsPage } from './pages/ProductionRequestsPage';
import { ProductionTasksPage } from './pages/ProductionTasksPage';

/**
 * OWNER: the `production` module agent (M6 — docs/MODULES.md).
 * Owns: apps/web/src/areas/production/**  ·  apps/api/src/modules/production/**
 *       packages/shared/src/contracts/production.ts
 *       packages/shared/src/i18n/{sv,en,zh}/production.json  ·  e2e/production.md
 *
 * Spec §5.9. The order DETAIL route is not a nav item — it is reached from the
 * list and from a task card, so it carries no permission of its own; the server
 * re-checks `production.orders.read` on every request it makes.
 */
export default defineArea({
  id: 'production',
  nav: [
    {
      section: 'production',
      to: '/production/orders',
      labelKey: 'common:nav.production.orders',
      icon: Factory,
      permissions: ['production.orders.read'],
      order: 10,
    },
    {
      section: 'production',
      to: '/production/tasks',
      labelKey: 'common:nav.production.tasks',
      icon: ClipboardCheck,
      permissions: ['production.tasks.manage', 'production.orders.read', 'production.requests.manage'],
      order: 20,
    },
    {
      section: 'production',
      to: '/production/requests',
      labelKey: 'common:nav.production.requests',
      icon: HandHelping,
      permissions: ['production.requests.create', 'production.requests.manage'],
      order: 30,
    },
  ],
  routes: [
    { path: 'production/orders', element: <ProductionOrdersPage /> },
    { path: 'production/orders/:id', element: <ProductionOrderDetailPage /> },
    { path: 'production/tasks', element: <ProductionTasksPage /> },
    { path: 'production/requests', element: <ProductionRequestsPage /> },
  ],
});
